// Simple event emitter to bridge isolated contexts
export const chatBridge = {
    onOpen: (callback: (data: any) => void) => {
        window.addEventListener('OPEN_GARGI_CHAT', (e: any) => callback(e.detail));
    },
    trigger: (data: { message: string }) => {
        const event = new CustomEvent('OPEN_GARGI_CHAT', { detail: data });
        window.dispatchEvent(event);
    }
};